export enum KpiObjectType {
  EQUIPMENT = 'EQUIPMENT',
  DAMAGE = 'DAMAGE',
}

export enum KpiModerationStatus {
  A_MODERER = 'A_MODERER',
  MODERE = 'MODERE',
}
